
import { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import CarouselRender from '../common/home/carousels/carousel-render';
import BrandItem from './brand-item';
import ProductsItem from './products-item';
import { getBrandsUser } from '../../actions/brands-user';
import { getProducts } from '../../actions/products-list';

import './products-list.css';

class ProductsListNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      focus: [],
      featured: [],
      activeBrand: 0,
      search: '',
    };
  }

  renderProductCarousel = (brand) => {
    const { products } = this.props;

    const temp = products.filter(product => (
      product.attributes.brand.name === brand.attributes.name
    ));

    return temp.map(item => (
      ProductsItem({
        image: item.attributes.links.image,
        id: item.id,
        name: item.attributes.name,
        rsp: item.attributes.rsp.toFixed(2),
        link: item.attributes.hyperlink,
        brand: item.attributes.brand.name
      })
    ));
  }

  handleBanner = (index) => {
    this.setState({
      activeBrand: index
    });
  }

  buildProductList = () => {
    const { brands, products } = this.props;

    const data = brands.map(brand => (
      this.renderProductCarousel(brand)
    ));

    let focus = brands.filter(brand => (
      brand.attributes.focus
    ));

    const banners = focus;

    focus = focus.map(item => (
      BrandItem({
        index: focus.indexOf(item),
        image: item.links.photo,
        name: item.attributes.name,
        handleBanner: this.handleBanner
      })
    ));

    let featured = products.filter(product => (
      product.attributes.featured
    ));

    featured = featured.map(item => (
      ProductsItem({
        image: item.attributes.links.image,
        id: item.id,
        name: item.attributes.name,
        featured: item.attributes.featured,
        rsp: item.attributes.rsp.toFixed(2),
        link: item.attributes.hyperlink,
        brand: item.attributes.brand.name
      })
    ));

    this.setState({
      data,
      banners,
      focus,
      featured,
      loading: false
    }, () => {
      if (this.state.search) {
        window.location.hash = `#${this.state.search}`;
      }
    });
  }

  renderBrandBanner = () => {
    const { links, attributes } = this.state.banners[this.state.activeBrand];
    const { history } = this.props;

    return (
      <div className="brand-carousel-banner-container">
        <img src={links.banner} alt={attributes.name} className="brand-carousel-banner-image" />
        {(attributes['banner-title'] || attributes['banner-text']) && (
          <div className="brand-carousel-content-container">
            <div className="brand-carousel-text-container">
              {attributes['banner-title'] && (
                <h3
                  id="brand-carousel-title"
                  style={{
                    color: attributes['banner-text-colour']
                  }}
                >
                  {attributes['banner-title'] || ''}
                </h3>
              )}
              <p
                id="brand-carousel-subtitle"
                style={{
                  color: attributes['banner-text-colour']
                }}
              >
                {attributes['banner-text'] || ''}
              </p>
              {attributes['banner-button-text'] && (
                <Button
                  id="brand-carousel-button"
                  className='red-btn'
                  onClick={() => {
                    if (attributes['banner-button-url'].match(/^https?:.*/i)) {
                      window.open(attributes['banner-button-url'], '_blank');
                    } else {
                      history.push(attributes['banner-button-url']);
                    }
                  }}
                >
                  {attributes['banner-button-text']}
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount = () => {
    const params = {};

    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (_, key, value) => { (params[key] = value); }
    );

    this.setState({
      search: params.brand
    });

    const { dispatch } = this.props;

    dispatch(getBrandsUser()).then(() => {
      dispatch(getProducts()).then(() => {
        this.buildProductList();
      });
    });
  }

  componentDidUpdate = (prevProps) => {
    const { dispatch, brands, products } = this.props;

    if (prevProps.brands !== brands && !!brands.length) {
      if (products.length > 0) {
        this.buildProductList();
      } else {
        dispatch(getProducts());
      }
    }

    if (prevProps.products !== products && !!products.length) {
      if (brands.length > 0) {
        this.buildProductList();
      } else {
        dispatch(getBrandsUser());
      }
    }
  }

  render() {
    const {
      loading,
      data,
      focus,
      featured
    } = this.state;
    const { brands } = this.props;
    const isMobileScreen = window.innerWidth <= 768;

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="products-list">
        {!!focus.length && !isMobileScreen && this.renderBrandBanner()}
        {!!focus.length && !isMobileScreen && <CarouselRender data={focus} />}
        {!!featured.length && <CarouselRender data={featured} title='Featured' />}
        {data.map(array => (
          !!array.length && (
            <CarouselRender
              key={brands[data.indexOf(array)].attributes.name}
              data={array}
              title={brands[data.indexOf(array)].attributes.name}
            />
          )
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  brands: state.brandsUser.brands,
  products: state.userProductsList.products
});

export default connect(mapStateToProps)(ProductsListNew);
